import React, { useState, useEffect } from 'react'

import { useQuery } from "@apollo/client"

import AppFrame from '../AppFrame'
import { QUERY_CONTACT_DATA } from '../data/services/graphqlQueries'
import ContactForm from '../components/ContactForm'
import { generateAddress, generatePhone, generateFax } from '../helpers/clinic'
import { displayFullHours } from '../helpers/officeHours'
import PageHeader from '../components/PageHeader'
import SectionHeader from '../components/SectionHeader'


export default ({globalData, clinic}) => {
  const [selectedClinic, setSelectedClinic] = useState('')
  const [messageSent, setMessageSent] = useState(false)

  const { loading, error, data } = useQuery(QUERY_CONTACT_DATA, {
    notifyOnNetworkStatusChange: true
  });

  if (loading) return null


  const generateLeftPanel = () => {
    if (clinic) {
      return <div className="text-normal md:text-lg">
        {/* <h1 className="text-xl md:text-2xl font-bold mb-2">{ clinic.name }</h1> */}
        <div className="mb-2">{ generateAddress(clinic) }</div>
        <div className="mb-2">tel: { generatePhone(clinic.phone) }</div>
        <div className="mb-4">fax: { generateFax(clinic.fax) }</div>
        <div className="text-sm mb-2">{ displayFullHours(clinic, 'text-black', 'text-black/50', 'text-black/50') }</div>
      </div>
    }

    return <div className="ecs-html" dangerouslySetInnerHTML={{__html: data.genericDescription[0].body}}></div>
  }

  const leftPanel = generateLeftPanel()

  return (
    <AppFrame data={globalData}>
      <div className="max-w-6xl mx-auto px-4 py-8 min-h-[400px]">
        <PageHeader title={ clinic ? clinic.name : 'Eye Clinics of Seattle'} subtitle={'contact'} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          { leftPanel }
          <div>
            <h2 className="text-xl font-semibold mb-2">Contact Form</h2>
            {
              !messageSent &&
              <React.Fragment>
                <div className="mb-4 text-xs md:text-sm">We look forward to hearing from you and will try to respond as soon as possible.</div>
                <ContactForm data={data} clinic={clinic} callback={setMessageSent} />
              </React.Fragment>
            }
            {
              messageSent &&
              <div>
                Thank you for contacting us! We will try to respond as soon as possible.<br/><br/>
                <button 
                  className="block bg-white border-2 py-4 border-gray-200 uppercase text-sm tracking-[2px] font-semibold w-full hover:border-gray-700 hover:bg-gray-700 hover:text-white disabled:text-gray-400"
                  onClick={() => { setMessageSent(false)}}
                >
                  Reset Message Form
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </AppFrame>
  )
}